import {
  ConfigFormItem,
  IAdvancedRichText,
  IWidgetParsedProps,
  RichTextAdvancedRender,
} from '@framework/engine';
import { DraggerInput, UploadInput } from '@framework/form';
import { default as React } from 'react';

export interface IUploadWidgetPreviewInputProps {
  options: IWidgetParsedProps;
  isButton: boolean;
  title: React.JSX.Element | undefined;
  helpText?: IAdvancedRichText;
  label?: IAdvancedRichText;
}

/**
 * Componente di preview per il widget di tipo upload
 */
export function UploadWidgetPreviewInput(
  props: IUploadWidgetPreviewInputProps,
) {
  const { options, isButton, title, helpText, label } = props;

  return (
    <ConfigFormItem
      name="upload"
      label={<RichTextAdvancedRender text={label} />}
      help={isButton && <RichTextAdvancedRender text={helpText} />}
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
    >
      {isButton ? (
        <UploadInput name="upload" title={title} multiLineButton />
      ) : (
        <DraggerInput
          name="upload"
          title={title}
          info={
            options.helpText ? (
              <RichTextAdvancedRender text={options.helpText} />
            ) : (
              <div />
            )
          }
        />
      )}
    </ConfigFormItem>
  );
}
